import React from 'react'
import Typography from "@material-ui/core/Typography";
import kardiaLogo from "../../assets/images/alivecor_logo.svg";

const Copyright = () => {
  return (
    <div>
      <img
        src={kardiaLogo}
        alt="AliveCor Logo"
        className="footerLogo"
        style={{
          width: "10rem",
          height: "auto",
          display: "block",
          marginLeft: "auto",
          marginRight: "auto",
          marginBottom: "0.5rem",
        }}
      />
      <Typography variant="body2" color="inherit" align="center">
        {"©"}
        {new Date().getFullYear()}{" "}
        {`AliveCor Inc. All Rights Reserved. US Patent Nos 8,301,232, 8,509,882 and Patents Pending. AliveCor and Kardia are trademarks of AliveCor, Inc. in the United States and other countries.`}
      </Typography>
    </div>
  );
}

export default Copyright
